import React from 'react';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import {useServerPause} from 'features/server/model/useServerMutations';
import ConfirmModal from 'shared/ui/Modal/ConfirmModal/ConfirmModal';
import IServerOutput from 'features/server/model/Server/IServer';

interface IServerPauseModalProps {
    item: IServerOutput,
    open: boolean;
    handleClose: () => void;
}

const ServerPauseModal: React.FC<IServerPauseModalProps> = ({ item, open, handleClose }) => {
    const {pause, isLoading} = useServerPause({uuid: item.uuid, handleClose});

    return (
        <ConfirmModal
            variant="pause"
            open={open}
            handleClose={handleClose}
            header={t`Приостановка сервера`}
            title={<Trans id="modal.server.pause.title" message="Вы уверены, что хотите приостановить сервер"/>}
            name={item.name}
            hint={
                <Trans
                    id="modal.server.pause.hint"
                    message="Открытые инциденты по серверу закроются, приём метрик от агента прекратится."
                />
            }
            confirmText={t`Приостановить`}
            onConfirm={pause}
            isLoading={isLoading}
        />
    );
};

export default ServerPauseModal;
